<template>
  <el-main class="app-main" :class="{ 'no-padding': isFullScreen }">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
    <fixedToolbar :right="0" :bottom="140" :scroll-container-selector="'.app-main'"
      @contact="onContact" @item-click="onItemClick" />
  </el-main>
</template>

<script>
import fixedToolbar from '@/components/fixedToolbar.vue';

export default {
  name: 'AppMain',
  components: { fixedToolbar },
  computed: {
    key() {
      return this.$route.path;
    },
    isFullScreen() {
      return this.$route.meta.fullScreen === true;
    }
  },
  methods: {
    onContact() {
      window.open('https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true', '_blank');
    },
    onItemClick(item) {
      console.log('点击了：', item);
    },
  }
}
</script>

<style scoped>
.app-main {
  min-height: calc(100vh - 60px);
  padding: 10px;
  margin-top: 60px;
  overflow-x: hidden;
  background-color: #f0f2f5;
}
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* 全屏页面的覆盖样式 */
.app-main.no-padding {
  padding: 0;
  /* margin-top: 0; */
  background-color: #fff;
}
</style>